export default __webpack_public_path__ + "static/media/banner_client.0d685539.png";